import { CatalogosProps } from "../interfaces/catalogos/CatalogosInterface";

export const catalogosList: CatalogosProps[] = [
    { id: '1', descripcion: 'Autoridad', path: '/administracion/catalogos/autoridad' },
    { id: '2', descripcion: 'Distrito Judicial', path: '/administracion/catalogos/distrito-judicial' },
    { id: '3', descripcion: 'Estatus', path: '/administracion/catalogos/estatus' },
    { id: '4', descripcion: 'Materia', path: '/administracion/catalogos/materia' },
    { id: '5', descripcion: 'Puesto', path: '/administracion/catalogos/puesto' },
    { id: '6', descripcion: 'Sala', path: '/administracion/catalogos/sala' },
    { id: '7', descripcion: 'Tipo de audiencia', path: '/administracion/catalogos/tipo-audiencia' },
    { id: '8', descripcion: 'Tipo de sesión', path: '/administracion/catalogos/tipo-sesion' },
    { id: '9', descripcion: 'Tipo de usuario', path: '/administracion/catalogos/tipo-usuario' },
];
